<template>
	<div
		class="left main main_white col-lg-10 col-md-10 col-xs-12"
		v-if="!shippmentDetails"
		v-bind:class="{ has_bg: !permanentorder && (showEnterScreen || showTips) }"
	>
		<h1 class="cat_title">כרמלה בקבוע</h1>
		<div
			class="bt_green bt_perma_go ease"
			v-if="permanentproducts && permanentproducts.length > 0 && !permOrder && permOrderLoaded"
			style=""
		>
			<a href="javascript:void(0);" v-if="true" @click.prevent="continueOrder">המשך לכתובת וזמני משלוח</a>
		</div>
		<div
			class="bt_green bt_perma_go show_perma_orders ease"
			v-if="permOrderEdit && permanentproducts.length > 0 && permOrder"
			style=""
		>
			<a href="javascript:void(0);" v-if="!saveingOrder" @click.prevent="saveNewOrder"> שמירה </a>
			<div class="permLoader savingOrderLoader" v-if="saveingOrder">
				<img :src="ajaxLoader" alt="" />
			</div>
		</div>
		<div class="loader dots" v-if="!permOrderLoaded">
			שנייה...כבר מעלים את ההזמנה הקבועה שלך
			<div class="permLoader">
				<img :src="ajaxLoader" alt="" />
			</div>
		</div>
		<div v-if="!permOrder || permOrderEdit">
			<div v-if="showEnterScreen && permOrderLoaded">
				<div class="perm-titlebtn clearfix z--1">
					<h2 class="right title" v-if="!permOrderEdit">כל מה שאוהבים, מגיע קבוע הביתה טרי וטעים!</h2>
					<h2 class="right title" v-if="permOrderEdit">
						אין לך יותר מוצרים בהזמנה הקבועה שלך. מה לעשות איתה?
					</h2>
					<div class="right bt_green ease" style="">
						<a href="javascript:void(0);" v-if="this.$store.state.allowPermOrder" @click="continuePermanent"
							>ליצירת הזמנה קבועה</a
						>
					</div>
					<div class="right bt_green ease" v-if="permOrderEdit" style="">
						<a
							href="javascript:void(0);"
							v-if="this.$store.state.allowPermOrder"
							@click.prevent="changeStatusAndSave(0, permOrder.id)"
							>להקפאת הזמנה</a
						>
					</div>
				</div>
				<div class="soon-coming" v-if="false"><img :src="assets_url + '/layout/soon-coming.jpg'" /></div>
				<div class="perma_rows z--1">
					<div class="perma_row clearfix">
						<div class="right perma_item">
							<div class="perma_icon">
								<HEART />
							</div>
							<div class="text">
								בחרת עגלה מלאה במוצרים אהובים. הפכת אותה להזמנה קבועה. מעכשיו היא תגיע אליך הביתה, באופן
								קבוע, פעם בשבוע (או פעמיים, לפי מה שנוח וצריך) כדי שתמיד יהיו דברים טעימים לבשל ולאכול.
							</div>
						</div>
						<div class="right perma_item">
							<div class="perma_icon">
								<OK />
							</div>
							<div class="text">זה אומר שמטלה אחת ירדה לך מהראש, ובצורה המפנקת ביותר.</div>
						</div>
						<div class="right perma_item">
							<div class="perma_icon">
								<PEN />
							</div>
							<div class="text">תמיד אפשר לערוך את ההזמנה, לשנות, להוסיף ולבטל.</div>
						</div>
					</div>
					<div class="perma_row clearfix">
						<div class="right perma_item">
							<div class="perma_icon">
								<TIME />
							</div>
							<div class="text">תמיד נשלח תזכורת יום לפני המשלוח, כדי לוודא שהכל בסדר.</div>
						</div>
						<div class="right perma_item">
							<div class="perma_icon">
								<PRESET />
							</div>
							<div class="text">מוצר מתנה בהפתעה עם כל משלוח</div>
						</div>
					</div>
					<div class="perm-order-notes">* ביצירת הזמנה קבועה פרטי האשראי ישמרו במערכת</div>
					<div class="mobile_only bt_green perma-botn ease" v-if="this.$store.state.allowPermOrder">
						<a href="javascript:void(0);" @click="continuePermanent">ליצירת הזמנה קבועה</a>
					</div>
				</div>
			</div>
			<div v-else-if="permOrderLoaded">
				<div class="perma_wrap row clearfix">
					<Side @searching="handelSearch" />
					<div class="right perma_main col-lg-9 col-md-12 col-xs-12">
						<div class="no_prod_wrap" v-if="showTips || !permanentproducts">
							<h2 class="title no_mobile" v-if="!hideText">כל מה שאוהבים, מגיע קבוע הביתה טרי וטעים!</h2>
							<div class="no_prod_tx" v-if="!hideText">
								עדיין אין מוצרים בהזמנה הקבועה.
								<span>אפשר להוסיף מוצרים להזמנה הקבועה בדרכים הבאות:</span>
							</div>
							<div class="perma_steps">
								<div class="perma_step">
									<div v-if="!hideText">
										<span>01</span> דרך החיפוש פה
										<div class="perm-r"></div>
									</div>
									<div class="mobile_only perma_search">
										<div class="perma_search head_search">
											<div class="head_search_input">
												<input
													type="text"
													placeholder="חיפוש להזמנה קבועה"
													autocomplete="off"
													v-bind:value="search"
													@input="(e) => (search = e.target.value)"
												/>
											</div>
											<div class="head_search_submit" v-if="search == ''">
												<input type="submit" value />
												<SEARCH />
											</div>
											<div class="head_search_close_search_perm" v-if="search != ''">
												<a href="javascript:void(0);" @click.prevent="closeSearch()">
													<CLOSE />
												</a>
											</div>
										</div>
										<div class="perma_results">
											<div
												class="perma_results_item clearfix"
												v-for="product in results"
												:key="product.id"
											>
												<div class="right cart_img"><img v-bind:src="product.image" /></div>
												<div class="right cart_title_wrap">
													<div class="cart_title" v-html="product.name"></div>
													<div class="pr_title_note" v-if="!product.hide_weight">
														{{ product.weight }}
														{{ product.weight_type }}
													</div>
													<div class="pr_price" v-bind:class="{ price_sale: product.onsale }">
														{{ product.price }} <span class="currency">{{ currency }}</span>
													</div>
													<div class="pr_price pr_price_old" v-if="product.oldprice">
														{{ product.oldprice }}
														<span class="currency">{{ currency }}</span>
													</div>
												</div>
												<div class="add_perma ease" @click="addToPermanent(product)">
													<a href="javascript:void(0);">
														<PLUS v-if="!isProductInPerm(product.id)" />
														<VOK v-else />
													</a>
												</div>
											</div>

											<div
												class="perma_results_item"
												v-if="results.length == 0 && search.length > 2"
											>
												מוזר, אבל אין לנו תוצאות ל״{{ search }}״
												<br />
												כנראה שאין לנו במלאי, אבל שווה לוודא שהקלדת נכון
											</div>
										</div>
									</div>
								</div>
								<div class="perma_step perma_step2" v-if="!hideText">
									<div>
										<span>02</span>
										<span class="perma_step2-tx"
											>דרך עמוד המוצר – פשוט לסמן "הוספה להזמנה קבועה״</span
										>
										<div class="perm-l"></div>
									</div>
								</div>
								<div class="perma_step" v-if="!hideText">
									<div>
										<span>03</span> ואפשר גם להעתיק עגלת קניות שלמה ולהפוך אותה להזמנה הקבועה, דרך
										<router-link
											:to="{ path: '/my-account/history', params: { state: 'history' } }"
										>
											היסטוריית הזמנות
										</router-link>
									</div>
								</div>
								<div class="bt_green" v-if="!hideText">
									<a href="javascript:void(0);" @click="toggleHideText">להתחלה</a>
								</div>
							</div>
						</div>
						<div class="has_prod_wrap" v-else>
							<div class="mobile_only search_grey">
								<div class="perma_search head_search">
									<div class="head_search_input">
										<input
											type="text"
											id=""
											autocomplete="off"
											placeholder="חיפוש להזמנה קבועה"
											v-bind:value="search"
											@input="(e) => (search = e.target.value)"
										/>
									</div>
									<div class="head_search_submit" v-if="search == ''">
										<input type="submit" value />
										<SEARCH />
									</div>
									<div class="head_search_close_search_perm" v-if="search != ''">
										<a href="javascript:void(0);" @click.prevent="closeSearch()">
											<CLOSE />
										</a>
									</div>
								</div>
								<div class="perma_results">
									<div
										class="perma_results_item clearfix"
										v-for="product in results"
										:key="product.id"
									>
										<div class="right cart_img"><img v-bind:src="product.image" /></div>
										<div class="right cart_title_wrap">
											<div class="cart_title" v-html="product.name"></div>
											<div class="pr_title_note" v-if="!product.hide_weight">
												{{ product.weight }}
												{{ product.weight_type }}
											</div>
											<div class="pr_price" v-bind:class="{ price_sale: product.onsale }">
												{{ product.price }} <span class="currency">{{ currency }}</span>
											</div>

											<div class="pr_price pr_price_old" v-if="product.oldprice">
												{{ product.oldprice }} <span class="currency">{{ currency }}</span>
											</div>
										</div>
										<div class="add_perma add_perma_ic ease" @click="addToPermanent(product)">
											<a href="javascript:void(0);">
												<PLUS v-if="!isProductInPerm(product.id)" />
												<VOK v-else />
											</a>
										</div>
									</div>
									<div class="perma_results_item" v-if="results.length == 0 && search.length > 2">
										מוזר, אבל אין לנו תוצאות ל״{{ search }}״
										<br />
										כנראה שאין לנו במלאי, אבל שווה לוודא שהקלדת נכון
									</div>
								</div>
							</div>
							<div class="row prod_has_remove flex flex--start">
								<div
									class="mobile_only title25 inner_width m-100 center"
									style="width: 100%"
									v-if="permanentproducts && permanentproducts.length > 0"
								>
									המוצרים שבחרת:
								</div>
								<Product
									v-bind:product="product"
									v-bind:index="index"
									v-for="(product, index) in permanentproducts"
									:key="product.id"
								></Product>
							</div>
							<div
								class="bt_green bt_perma_go show_perma_orders ease"
								style="text-align: left"
								v-if="permOrderEdit && permanentproducts.length > 0 && permOrder"
							>
								<a
									href="javascript:void(0);"
									style="position: static; margin-top: 20px"
									v-if="!saveingOrder"
									@click.prevent="saveNewOrder"
								>
									שמירה
								</a>
								<div class="permLoader savingOrderLoader" style="position: static" v-if="saveingOrder">
									<img :src="ajaxLoader" alt="" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<div v-if="permOrder && permOrderLoaded">
				<div class="perma_info_box clearfix">
					<div class="left perma_info_col1 clearfix">
						<div class="perma_info_title">
							סטטוס מנוי
							<div
								class="type_info hasTooltip"
								title="ניתן להקפיא את המנוי ולא נשלח לך מוצרים טעימים עד שיוחזר למצב 'פעיל'"
							>
								?
							</div>
						</div>
						<div class="status_box clearfix" v-if="permOrder.status != '-1'">
							<div class="right status_item ease" :class="{ active: permOrder.status == '1' }">
								<a href="javascript:void(0);" @click.prevent="changeStatus(1, permOrder.id)">פעיל</a>
							</div>
							<div class="right status_item ease" :class="{ active: permOrder.status == '0' }">
								<a href="javascript:void(0)" @click.prevent="changeStatus(0, permOrder.id)">מוקפא</a>
							</div>
						</div>
					</div>
					<div class="right perma_info_col3">
						<div class="perma_info_num">{{ permOrder.products.length }}</div>
						<div class="text">פריטים בהזמנה</div>
						<div class="green_link">
							<a href="javascript:void(0);" @click="editOrder(permOrder)">עריכת מוצרים</a>
						</div>
					</div>
					<div class="right perma_info_col2">
						<div class="perma_info_title">
							כתובת וזמני משלוח
							<Calendar />
						</div>
						<div class="clearfix">
							<div class="right text">
								{{ permOrder.address }}
								<br />
							</div>
							<div class="right text">
								<div v-for="row in permOrder.time" :key="row.time + '-' + row.day">
									יום {{ days[Number(row.day) - 1] }} {{ row.time }}
								</div>

								<br />
							</div>
							<div class="right text" style="min-height: 20px"></div>
						</div>
						<div class="green_link">
							<a href="javascript:void(0);" @click="editOrderDetails(permOrder)">עריכת פרטי משלוח</a>
						</div>
					</div>
				</div>
				<div class="row prod_in_order">
					<!-- <Product v-for="product in permOrder.products" :product="product" :readonly="true" :key="product.id"/> -->
					<ProductsTable :products="permOrder.products" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { EventBus } from "@/event-bus";
	import Product from "../../components/Product/Product.vue";
	import ProductsTable from "./Components/ProductsTable.vue";
	import Side from "./Components/PermenantSide.vue";
	import PLUS from "../../assets/img/plus.svg";
	import CLOSE from "../../assets/img/close.svg";
	import VOK from "../../assets/img/ok.svg";
	import FrozenPop from "../../components/Popups/FrozenPerOrderPopup.vue";
	// import OrderDetails from "./Components/PermenantOrderDetails";
	/* SVG import */
	import HEART from "../../assets/img/heart.svg";
	import OK from "../../assets/img/check-ok.svg";
	import PEN from "../../assets/img/pen-magic.svg";
	import SEARCH from "../../assets/img/search.svg";
	import TIME from "../../assets/img/time2.svg";
	import PRESET from "../../assets/img/present.svg";
	import Calendar from "../../assets/img/calander.svg";
	import { mapActions, mapGetters, mapState } from "vuex";
	import OrderUpdatedPopup from "../Popups/OrderUpdatedPopup";
	import OrderStatusChange from "../Popups/orderStatusChange";
	import PerOrderSent from "../Popups/PerOrderSent";
	import PerOrderSentNotEdit from "../Popups/PerOrderSentNoEdit";

	export default {
		name: "PermenantOrder",
		data() {
			return {
				currency: wpData.currencySumbol,
				loaderGif: wpData.assets_url + "/layout/loader.gif",
				ajaxLoader: wpData.assets_url + "/layout/ajax-loader.gif",
				orderStarted: false,
				pageLoaded: false,
				permanentorder: false,
				continueEnter: false,
				hideText: false,
				hideTips: false,
				search: "",
				products: [],
				showTips: true,
				shippmentDetails: false,
				editPerOrder: false,
				editPerOrderNew: false,
				assets_url: wpData.assets_url,
				orderToEdit: this.permOrder,
				saveingOrder: false,
				orders: [],
				allOrders: [],
				days: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי"],
			};
		},
		watch: {
			orders: function (value) {
				if (value) {
					this.permanentorder = true;
				}
			},
			search: function (value) {
				if (value && value.length > 2) {
					this.searchProducts(value);
				}
			},
		},
		computed: {
			...mapGetters(["allProducts"]),
			...mapState(["permOrder", "permOrderNew", "permOrderEdit", "permOrderLoaded"]),
			user() {
				return this.$store.state.userLoggedInfo;
			},
			orderSent() {
				let waiting_order = false;
				this.allOrders.map((order) => {
					if (
						typeof order == "object" &&
						order.is_edit &&
						typeof order.meta.is_perm_order_copy != "undefined" &&
						order.meta.is_perm_order_copy[0] == "1"
					) {
						waiting_order = true;
					}
				});
				return waiting_order;
			},
			waitingOrder() {
				let waiting_order = false;
				this.allOrders.map((order) => {
					if (
						typeof order == "object" &&
						order.is_edit &&
						typeof order.meta.is_perm_order_copy != "undefined" &&
						order.meta.is_perm_order_copy[0] == "1"
					) {
						waiting_order = order;
					}
				});
				return waiting_order;
			},

			nowDate() {
				let todayDate = new Date();
				var mounth = todayDate.getMonth() + 1;
				if (mounth < 10) {
					mounth = "0" + mounth;
				}
				var day = todayDate.getDate();
				if (day < 10) {
					day = "0" + day;
				}
				var year = todayDate.getFullYear().toString();
				year = year.replace("20", "");
				return `${day}/${mounth}/${year}`;
			},
			orderStartedComputed() {
				var orderStarted = false;
				if (this.allOrders) {
					this.allOrders.map((order) => {
						if (
							typeof order == "object" &&
							typeof order.meta.is_perm_order_copy != "undefined" &&
							order.meta.is_perm_order_copy[0] == "1"
						) {
							if (order.is_edit != 1) {
								// eslint-disable-next-line vue/no-side-effects-in-computed-properties
								this.orderStarted = order;
								orderStarted = order;
							}
						}
					});
					return orderStarted;
				}

				return orderStarted;
			},
			showEnterScreen() {
				if (this.continueEnter || this.editPerOrder || this.permanentproducts) {
					return false;
					//return true;
				}
				return true;
			},
			initTooltips() {
				if (this.permOrder) {
					this.$store.dispatch("initToolTip");
				}
				return true;
			},
			results() {
				if (!this.search || this.search == "") {
					return false;
				}
				// var productsFound = this.products.filter(product => {
				//   return product.name.toLowerCase().includes(this.search.toLowerCase());
				// });
				return this.products;
			},
			permanentproducts() {
				if (this.$store.state.permanentproducts && this.$store.state.permanentproducts.length > 0) {
					this.showTips = false;
					return this.$store.state.permanentproducts;
				}
				this.showTips = true;
				return false;
			},
		},
		mounted() {
			this.$ajax
				.get(ajaxUrl + "?action=getOrders")
				.then((response) => {
					this.loaded = true;
					if (response.data) {
						this.allOrders = response.data;
						if (this.allOrders) {
							this.allOrders.map((order) => {
								if (
									typeof order == "object" &&
									typeof order.meta.is_perm_order_copy != "undefined" &&
									order.meta.is_perm_order_copy[0] == "1"
								) {
									if (order.is_edit != 1) {
										if (this.nowDate == order.meta.jckwds_date[0]) {
											// eslint-disable-next-line vue/no-side-effects-in-computed-properties
											this.orderStarted = order;
										}
									}
								}
							});
						}
					}
				})
				.catch((e) => console.log(e));
			this.$root.$on("edit-order", () => {
				console.log("edit order");
				this.forceEditOrder();
			});
			this.$root.$on("editPermOrder", (event) => {
				if (typeof event != "undefined" && typeof event.editOrder != "undefined") {
					this.editOrder(this.permOrder, true);
				}
			});
			const $this = this;

			if (this.permanentproducts) {
				this.continuePermanent();
			}
		},
		created() {
			EventBus.$on("permanentOrderNew", this.continueOrder);
			EventBus.$on("permanentOrderSave", this.saveNewOrder);
		},
		methods: {
			...mapActions(["addToPermanent"]),
			toggleHideText() {
				this.hideText = true;
				window.scrollTo(0, 0);
			},
			toggleShowTips() {
				this.showTips = false;
			},

			searchProducts(s) {
				//this.loadingResults = true;
				this.$ajax({
					method: "POST",
					url: homeUrl + "ajax.php",
					params: {
						search: s,
					},
				})
					.then((res) => {
						let foundProducts = res.data;
						if (typeof foundProducts != "undefined" && foundProducts.length > 0) {
							foundProducts.sort(function (a, b) {
								if (
									a.categories.includes(16) ||
									a.categories.includes(105) ||
									a.categories.includes(22)
								) {
									return -1;
								}
								if (
									b.categories.includes(16) ||
									b.categories.includes(105) ||
									b.categories.includes(22)
								) {
									return 1;
								}
								return 0;
							});
						}
						//this.loadingResults = false;
						this.products = foundProducts;
						// resolve(foundProducts);
					})
					.catch((e) => {
						console.log(e);
					});
			},
			saveNewOrder() {
				if (
					wpData.minimum_order.active &&
					this.$store.state.cartTotal < parseFloat(wpData.minimum_order.amount)
				) {
					this.$modal.show("minimum-order");
					return;
				}

				this.saveingOrder = true;
				let products_to_send = this.$store.getters.cartJSON ? this.$store.getters.cartJSON : false;
				this.$store.state.permOrder.products = this.$store.state.added;

				this.$store.dispatch("updatePermanentOrder", products_to_send).then(() => {
					this.$modal.show(OrderStatusChange, { status: 1, sendToComax: false });
					this.orderToEdit = false;
					this.editPerOrder = false;
					this.saveingOrder = false;
					this.$store.state.added = [];
					this.$store.commit("setPerEdit", false);
				});
			},
			changeStatus(status, order_id) {
				this.$store.state.permOrder.status = status;
				this.changeOrderStatus([status, order_id]);
				this.$store.commit("setPermOrderEdit", false);
				this.$modal.show(OrderStatusChange, { status: status, sendToComax: true });
			},
			changeStatusAndSave(status, order_id) {
				this.saveOrderStatus([status, order_id]);
				this.$store.commit("setPermOrderEdit", false);
				this.$modal.show(OrderStatusChange, { status: status, sendToComax: false });
			},
			getProduct(id) {
				let tmp = this.allProducts;
				return tmp.find((p) => p.id == id);
			},
			continuePermanent() {
				this.continueEnter = true;
				if (typeof this.$route.query.new_order == "undefined") {
					if (!this.$store.state.permOrderEdit) {
						this.$store.dispatch("clarCart");
					}
				}
				window.scrollTo(0, 0);
				this.$store.commit("setPermOrderNew", true);
			},
			handelSearch(value) {
				if (value) {
					this.showTips = false;
				}
			},
			continueOrder() {
				if (
					wpData.minimum_order.active &&
					this.$store.state.cartTotal < parseFloat(wpData.minimum_order.amount)
				) {
					this.$modal.show("minimum-order");
					return;
				}

				this.shippmentDetails = true;
				this.$store.commit("setPremenantOrder", true);
				let indexesToRemove = [];
				let perProductsToAdd = this.$store.state.permanentproducts;
				perProductsToAdd.map((product) => {
					this.$store.dispatch("updateCart", [product]);
				});
				/*
      let cart = this.$store.state.added;
    console.log(cart);
    console.log(this.$store.state.permanentproducts);
      for (const key in cart) {
          let find = this.$store.state.permanentproducts.find(p => p.id == cart[key].id )
        console.log(find);
          if (typeof find == 'undefined'){
              indexesToRemove.push(key);
          }
      }
      indexesToRemove.map(index => {
          this.$store.state.added.splice(index,1);
      })
      */

				if (this.editPerOrder) {
					this.$store.commit("setPerEdit", this.orderToEdit);
				}
				this.$router.replace({
					path: "/checkout/",
				});
			},
			editOrderDetails(order) {
				if (order.status != "1") {
					this.$modal.show(FrozenPop, {});
					return;
				}
				this.clarCart();

				this.$store.commit("setPremenantOrder", true);

				this.editPerOrder = true;
				this.$store.commit("clearPermenant");
				this.$store.commit("setPerEdit", order);
				order.products.map((product) => {
					this.$store.commit("setPermenant", product);
					this.$store.dispatch("updateCart", [product]);
				});

				this.$router.replace({
					path: "/checkout/",
				});
			},
			forceEditOrder() {
				let order = this.permOrder;
				this.clarCart();
				this.$store.commit("hideAlert", true);
				this.$store.commit("setPermOrderEdit", true);
				this.orderToEdit = order;
				this.$store.commit("clearPermenant");
				this.$store.commit("setPerEdit", order);
				order.products.map((product) => {
					this.$store.dispatch("updateCart", [product]);
					this.$store.commit("setPermenant", product);
				});
				this.$store.commit("hideAlert", false);
			},
			editOrder(order, send = false) {
				if (this.orderStarted) {
					this.$modal.show(
						PerOrderSentNotEdit,
						{ order: this.orderStarted },
						{},
						{
							"edit-order": this.forceEditOrder,
						}
					);
					return;
				}
				if (!send && order && order.order_sent && this.orderSent) {
					this.$modal.show(PerOrderSent, { order: this.waitingOrder });
					return;
				}
				if (order.status != "1") {
					this.$modal.show(FrozenPop, {});
					return;
				}
				this.clarCart();
				this.$store.commit("hideAlert", true);
				this.$store.commit("setPermOrderEdit", true);
				this.orderToEdit = order;
				this.$store.commit("clearPermenant");
				this.$store.commit("setPerEdit", order);
				order.products.map((product) => {
					this.$store.dispatch("updateCart", [product]);
					this.$store.commit("setPermenant", product);
				});
				this.$store.commit("hideAlert", false);
			},
			closeSearch() {
				this.search = "";
			},
			isProductInPerm(productID) {
				if (this.permanentproducts) {
					let product = this.permanentproducts.find((p) => p.id == productID);
					if (product) {
						return true;
					}
				}
				return false;
			},
			...mapActions([
				"updateCart",
				"getProductById",
				"incrementProduct",
				"decrementProduct",
				"removeProduct",
				"updateSelect",
				"clarCart",
				"changeOrderStatus",
				"saveOrderStatus",
			]),
		},
		components: {
			Product,
			HEART,
			OK,
			PEN,
			SEARCH,
			TIME,
			PRESET,
			Side,
			PLUS,
			CLOSE,
			VOK,
			//  OrderDetails,
			Calendar,
			ProductsTable,
		},
	};
</script>
<style>
	@media (max-width: 480px) {
		.main_white {
			background: #efede9 !important;
		}

		.perma_main .mobile_only.title25 {
			margin-bottom: 1em;
		}

		.perm-order-notes {
			margin: 4em 0 -5em !important;
		}

		.perma_rows {
			margin-top: 1em;
		}

		.perma_item {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			margin-bottom: 15px;
		}

		.perma_item .perma_icon {
			flex: 0 0 52px;
			margin: 0 !important;
			background: #fff;
		}

		.perma_item .text {
			text-align: right;
			line-height: normal;
		}

		.perm-titlebtn .bt_green {
			display: none;
		}
	}
	.perma_results {
		overflow-y: scroll;
		overflow-x: hidden;
		max-height: 425px;
		position: relative;
		width: 100%;
		z-index: 3;
		background: #fff;
	}
	.permLoader img {
		max-width: 40px;
		margin: 20px;
	}
	.permLoader.savingOrderLoader {
		text-align: left;
		position: absolute;
		left: 50px;
		top: 15px;
	}
	.prod_in_order .product_wrap .addto_amount {
		pointer-events: none;
	}

	@media screen and (max-width: 800px) {
		.permLoader.savingOrderLoader {
			text-align: left;
			position: absolute;
			left: 0;
			top: -20px;
		}
	}
</style>

<style scoped lang="sass">
	.row.prod_in_order
	  margin-bottom: 14rem

	.perm-order-notes
	  margin: 4em 0 -4em
	  font-size: 14px
	  font-style: italic

	/* Mobile */
	@media screen and (max-width: 800px)
	  .row.prod_in_order
	    margin-bottom: 3rem
</style>
